import {
    GET_TIPS,
    GET_STATE_LOADING
} from "./types/getters.js";

const getters = {
    [GET_TIPS]: state => state.tips,
    [GET_STATE_LOADING]: state => state.loading
};

export default getters;
